<template>
  <div class="selectScenery">
    <div class="top" :class="{'isiOSX':isiOSX}">
      <div class="nav">
        <p class="back" @click="citySelect()">
          杭州
          <img src="./../../assets/takingCar/unfold.png" alt />
        </p>
        <p class="title">请选择机场</p>
        <p class="esc" @click="goback()">取消</p>
      </div>
    </div>
    <div class="content">
      <div
        class="list"
        v-for="(item,index) in sceneryList"
        :key="index"
        @click="endSelect(item.name)"
      >
        <p>{{item.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      sceneryList: [
        { name: "杭州萧山国际机场T1航站楼" },
        { name: "杭州萧山国际机场T2航站楼" },
        { name: "杭州萧山国际机场T3航站楼" }
      ]
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  watch: {
    $route: "getPath"
  },
  methods: {
    citySelect() {
      console.log("进入城市选择页面");
    },
    goback() {
      console.log("返回首页");
    },
    endSelect(end) {
      console.log("目的地：" + end + "=>进入接机页面");
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.selectScenery {
  min-height: 100%;
  background: #ffffff;
  .top {
    box-shadow: 1px 2px 4px rgba(24, 24, 24, 0.06);
    padding-top: 24px;
    .nav {
      margin: 0 20px;
      height: 40px;
      position: relative;
      p {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #333333;
        font-weight: bolder;
        img {
          width: 13px;
        }
      }
      p:nth-child(1) {
        position: absolute;
        top: 0;
        left: 0;
      }
      p:nth-child(2) {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      p:nth-child(3) {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  .content {
    margin: 0 15px;
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    .list {
      p {
        padding: 15px 0;
        border-bottom: 0.5px solid #dddddd;
        font-weight: 500;
      }
    }
  }

  .isiOSX {
    padding-top: 44px;
  }
}
</style>
